var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{class:_vm.widgetClass,attrs:{"header":_vm.widget.title}},[_vm._v("\n    "+_vm._s(_vm.widget.description)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }